let zenchefObserver : IntersectionObserver|null = null;

function initLazyLoadedZenchef() {
	if ( !( 'IntersectionObserver' in window ) ) {
		const iframes = document.querySelectorAll( 'iframe[zenchef-iframe][lazy-src]' );
		iframes.forEach( ( iframe ) => {
			const src = iframe.getAttribute( 'lazy-src' );
			if ( src ) {
				iframe.setAttribute( 'src', src );
				iframe.removeAttribute( 'lazy-src' );
				iframe.removeAttribute( 'zenchef-iframe' );
			}
		} );

		return;
	}

	if ( !zenchefObserver ) {
		zenchefObserver = new IntersectionObserver( ( entries ) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					const iframe = entry.target;
					const src = entry.target.getAttribute( 'lazy-src' );
					if ( src ) {
						iframe.setAttribute( 'src', src );
						iframe.removeAttribute( 'lazy-src' );
						iframe.removeAttribute( 'zenchef-iframe' );
						zenchefObserver?.unobserve( iframe );
					}
				}
			} );
		} );
	}

	const iframes = document.querySelectorAll( 'iframe[zenchef-iframe][lazy-src]' );
	iframes.forEach( ( iframe ) => {
		zenchefObserver?.observe( iframe );
	} );
}

initLazyLoadedZenchef();
requestAnimationFrame( () => {
	initLazyLoadedZenchef();
} );
window.addEventListener( 'load', () => {
	initLazyLoadedZenchef();
} );
